import { useSidebarStore } from '@/stores/sidebarStore';
import { useThemeStore } from '@/stores/themeStore';
import { computed, reactive } from 'vue';

const layoutConfig = reactive({
    preset: 'Aura',
    primary: 'bav-blue', // Use our custom BAV blue color
    surface: null,
    menuMode: 'static'
});

const layoutState = reactive({
    staticMenuDesktopInactive: false,
    overlayMenuActive: false,
    profileSidebarVisible: false,
    configSidebarVisible: false,
    staticMenuMobileActive: false,
    menuHoverActive: false,
    activeMenuItem: null,
    menuCollapsed: false
});

export function useLayout() {
    // Initialize themeStore inside the composable function
    const themeStore = useThemeStore();
    const sidebarStore = useSidebarStore();

    layoutState.menuCollapsed = sidebarStore.istEingeklappt;

    const setActiveMenuItem = (item) => {
        layoutState.activeMenuItem = item.value || item;
    };

    const toggleDarkMode = () => {
        if (!document.startViewTransition) {
            themeStore.toggleTheme();
            return;
        }

        document.startViewTransition(() => themeStore.toggleTheme());
    };

    const toggleMenu = () => {
        if (layoutConfig.menuMode === 'overlay') {
            layoutState.overlayMenuActive = !layoutState.overlayMenuActive;
        }

        if (window.innerWidth > 991) {
            layoutState.staticMenuDesktopInactive = !layoutState.staticMenuDesktopInactive;
        } else {
            layoutState.staticMenuMobileActive = !layoutState.staticMenuMobileActive;
        }
    };

    const isSidebarActive = computed(() => layoutState.overlayMenuActive || layoutState.staticMenuMobileActive);

    const isDarkTheme = computed(() => themeStore.isDarkMode);

    const getPrimary = computed(() => layoutConfig.primary);

    const getSurface = computed(() => layoutConfig.surface);

    const toggleMenuCollapse = () => {
        // Im Desktop-Modus umschalten, in Mobilmodus nicht erlaubt
        if (window.innerWidth > 991) {
            layoutState.menuCollapsed = !layoutState.menuCollapsed;

            sidebarStore.istEingeklappt = layoutState.menuCollapsed;
        }
    };

    return {
        layoutConfig,
        layoutState,
        toggleMenu,
        toggleMenuCollapse,
        isSidebarActive,
        isDarkTheme,
        getPrimary,
        getSurface,
        setActiveMenuItem,
        toggleDarkMode
    };
}
